import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';

const GOLD = '#C9973A';

const CAROUSEL_IMAGES = [
    {
        url: 'https://machanents.com/media/product/RGSN0329-1.jpg',
        label: 'Armenian Gorg — Traditional Hand-Woven Carpet',
    },
    {
        url: 'https://www.originalarmenia.com/wp-content/uploads/2020/04/armenian-wine-areni.jpg',
        label: 'Armenian Wine, Made of Armenian Grape',
    },
];

export default function AuthLayout({ children }) {
    const [index, setIndex]   = useState(0);
    const [fade,  setFade]    = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
            setFade(false);
            setTimeout(() => {
                setIndex(i => (i + 1) % CAROUSEL_IMAGES.length);
                setFade(true);
            }, 600);
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    const goTo = (i) => {
        if (i === index) return;
        setFade(false);
        setTimeout(() => { setIndex(i); setFade(true); }, 300);
    };

    return (
        <Box sx={{ display: 'flex', flexGrow: 1, minHeight: '100%' }}>

            {/* ── Left: form panel ── */}
            <Box sx={{
                width: { xs: '100%', md: '50%' },
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                overflowY: 'auto',
                px: { xs: 2, sm: 4, md: 5 },
                py: { xs: 4, md: 6 },
                background: '#FFFFFF',
            }}>
                <Box sx={{ width: '100%', maxWidth: 480 }}>
                    {children}
                </Box>
            </Box>

            {/* ── Right: image carousel ── */}
            <Box sx={{
                width: '50%',
                display: { xs: 'none', md: 'block' },
                position: 'relative',
                overflow: 'hidden',
                flexShrink: 0,
            }}>
                {/* Fading background images */}
                {CAROUSEL_IMAGES.map((img, i) => (
                    <Box key={i} sx={{
                        position: 'absolute',
                        inset: 0,
                        backgroundImage: `url("${img.url}")`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: i === index ? (fade ? 1 : 0) : 0,
                        transition: 'opacity 0.65s ease-in-out',
                    }} />
                ))}

                {/* Gradient overlay */}
                <Box sx={{
                    position: 'absolute', inset: 0,
                    background: 'linear-gradient(to top, rgba(44,31,20,0.72) 0%, rgba(44,31,20,0.18) 50%, rgba(44,31,20,0.08) 100%)',
                }} />

                {/* Brand watermark top-left */}
                <Box sx={{ position: 'absolute', top: 28, left: 28, zIndex: 2 }}>
                    <Typography sx={{
                        color: 'white',
                        fontFamily: "'Playfair Display', Georgia, serif",
                        fontWeight: 900,
                        fontSize: '1.5rem',
                        letterSpacing: '0.04em',
                        textShadow: '0 2px 12px rgba(0,0,0,0.5)',
                    }}>
                        🇦🇲 HayTour
                    </Typography>
                </Box>

                {/* Image label — bottom left */}
                <Box sx={{
                    position: 'absolute', bottom: 56, left: 28, zIndex: 2,
                    opacity: fade ? 0.8 : 0, transition: 'opacity 0.65s ease',
                }}>
                    <Typography variant="caption" sx={{
                        color: 'white',
                        letterSpacing: '0.08em',
                        fontSize: '0.75rem',
                    }}>
                        {CAROUSEL_IMAGES[index].label}
                    </Typography>
                </Box>

                {/* Dot indicators — bottom center */}
                <Box sx={{
                    position: 'absolute', bottom: 22, left: 0, right: 0,
                    display: 'flex', justifyContent: 'center', gap: 1, zIndex: 2,
                }}>
                    {CAROUSEL_IMAGES.map((_, i) => (
                        <Box key={i}
                             onClick={() => goTo(i)}
                             sx={{
                                 width: i === index ? 24 : 8, height: 8,
                                 borderRadius: 4,
                                 bgcolor: i === index ? GOLD : 'rgba(255,255,255,0.45)',
                                 transition: 'all 0.4s ease',
                                 cursor: 'pointer',
                             }} />
                    ))}
                </Box>
            </Box>
        </Box>
    );
}
